import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_DASHBOARD_TABS = defineFcm('starter_experience_dashboard_tabs')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				experiment: { type: 'string' },
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		experiment: '',
	})
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'Starter Petition Dashboard',
		description:
			'If true, the users are treated into an A/B testing experiment to show a different layout on the dashboard to include Tabs',
		import: false,
		template: {
			isEnabled: false,
			experiment: 'starter_experience_dashboard_tabs_v03',
		},
		deprecated: 'No references found. Safe to delete after 2026-09-21.',
	});
